module.exports = __webpack_public_path__ + "static/media/course_grid.0a2b08ae.png";